import { MemoizedMarkdown } from '@/shared/ui/primitives';

export interface PatientNoteViewProps {
  note: string;
  noteId: string;
}

export function PatientNoteView({ note, noteId }: PatientNoteViewProps) {
  const trimmed = note.trim();
  if (trimmed.length === 0) {
    return <p className="text-sm text-muted-foreground">No note yet.</p>;
  }

  return (
    <div className="text-sm leading-snug text-foreground">
      <MemoizedMarkdown id={noteId} content={trimmed} />
    </div>
  );
}
